import { useEffect } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _DOCFolder, _DOCTrdDocument, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_LG, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable, MASK_BOOLEAN_ICON } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { BasicPage } from "../../../theme/Component/BasicPage";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { toast } from "react-toastify";
import { EditorDOCDocumentType } from "../DOCDocumentType/EditorDOCDocumentType";
import { SelectTrdsID } from "../../../admin/configuracion/TrdID/SelectTrdsID";
import { SingPanelEditor } from "../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";
import { EditorDOCMimeTypes } from "../../../theme/Component/EditorMymeTypes";


interface ComponentData {
    isModal?: boolean;
    _onChange?: Function;
}

export const DOCTrdDocument = ({ isModal, _onChange }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista, addRequiredFields, validateForm, isRequired, isMissing } = useDataBean(_DOCTrdDocument);
    const paginator = usePaginator();

    const modal = useModal("", MODAL_LG);
    const modalC = useModal("Eliminar Documento tipo TRD", MODAL_SM);

    useEffect(() => {
        addRequiredFields(["Code", "Name"])
    }, [])

    useEffect(() => {
        getLista();
    }, [paginator.page])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getDOCTrdDocumentCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(err => {
            toast.error("Error al cargar los documentos Tipo TRD");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            MaxFileSize: 0,
            AllowAnnexes: false,
            AllowComments: false,
            AutoClassify: false,
            BPMRequired: false,
            MultipleFiles: false,
            RequiredExpiration: false,
            RequiredMetadata: false,
            RequiredOCR: false,
            RequiredSignature: false,
            RequiredVersionControl: false,
        });
        modal.open("Agregar Documneto Tipo TRD");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }
        instance.updateDOCTrdDocument(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDDOCTrdDocument', visible: true },
        { title: 'Codigo', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Nivel Confidencial', property: 'ConfidentialLevel', visible: true },
        { title: 'Tamaño maximo', property: 'MaxFileSize', visible: true },
        { title: 'Archivos permitidos', property: 'MimeTypes', visible: true },
        { title: 'Multiples Documentos', property: 'MultipleFiles', visible: true },
        { title: 'Tipo Documental', property: '', visible: true }, //IDDOCDocumentType
        { title: 'Documento TRD', property: '', visible: true }, //IDLnTrd
        { title: 'Permite Anexos', property: 'AllowAnnexes', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Permite Comentarios', property: 'AllowComments', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'AutoClasificar', property: 'AutoClassify', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Requiere BPM', property: 'BPMRequired', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Requiere Vencimiento', property: 'RequiredExpiration', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Requiere Metadata', property: 'RequiredMetadata', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Requiere OCR', property: 'RequiredOCR', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Requiere Versionamiento', property: 'RequiredVersionControl', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Requiere Firmas', property: 'RequiredSignature', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Panel de Firmas', property: '', visible: true }, //IDSignAndApprovalPanel
        { title: 'Años de Retencion', property: 'RetentionYears', visible: true }, //IDSignAndApprovalPanel
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar Documento Tipo TRD ${bean.Name}`); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const setValue = (e) => {
        _onChange?.(e);
        setBean(e);
    }

    const baseComponent = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setValue}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        records={paginator}
                    />
                </div>
                <div className="col-md-12">

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${isMissing('Code') ? 'has-error' : ''}`}>Codigo {isRequired('Code') ? <span className="text-danger">*</span> : ''}</label>
                                <input className="form-control" type="text" value={bean.Code} onChange={(e) => { setBean({ ...bean, Code: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${isMissing('Name') ? 'has-error' : ''}`} >Nombre {isRequired('Name') ? <span className="text-danger">*</span> : ''}</label>
                                <input className="form-control" type="text" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nivel de Confidencialidad</label>
                                <input className="form-control" type="number" value={bean.ConfidentialLevel} onChange={(e) => { setBean({ ...bean, ConfidentialLevel: e.target.value ? Number(e.target.value) : "" }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Tipo Documental</label>
                                <EditorDOCDocumentType idSelector={bean.IDDOCDocumentType} onChange={(e) => { setBean({ ...bean, IDDOCDocumentType: e.IDDOCDocumentType }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectTrdsID trdIDLn={bean.IDLnTrd} onChange={(e) => { setBean({ ...bean, IDLnTrd: e.IDLn }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Tamaño Maximo de archivo</label>
                                <input type="number" className="form-control" value={bean.MaxFileSize} onChange={(e) => { setBean({ ...bean, MaxFileSize: e.target.value ? parseFloat(e.target.value) : null }) }} />
                            </div>

                            <div className="col-md-6">
                                <BasicSwitch label="Permite Anexos" estado={bean.AllowAnnexes} eventChange={(e) => { setBean({ ...bean, AllowAnnexes: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Permite Comentarios" estado={bean.AllowComments} eventChange={(e) => { setBean({ ...bean, AllowComments: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Autoclasificar" estado={bean.AutoClassify} eventChange={(e) => { setBean({ ...bean, AutoClassify: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Requiere BPM" estado={bean.BPMRequired} eventChange={(e) => { setBean({ ...bean, BPMRequired: e }) }} />
                            </div>

                            <div className="col-md-6">
                                <BasicSwitch label="Permite multiples archivos" estado={bean.MultipleFiles} eventChange={(e) => { setBean({ ...bean, MultipleFiles: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Requiere fecha de vencimiento" estado={bean.RequiredExpiration} eventChange={(e) => { setBean({ ...bean, RequiredExpiration: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Requiere Metadata" estado={bean.RequiredMetadata} eventChange={(e) => { setBean({ ...bean, RequiredMetadata: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Requiere OCR" estado={bean.RequiredOCR} eventChange={(e) => { setBean({ ...bean, RequiredOCR: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Requiere Firma" estado={bean.RequiredSignature} eventChange={(e) => { setBean({ ...bean, RequiredSignature: e }) }} />
                            </div>
                            {bean.RequiredSignature &&
                                <div className="col-md-6">
                                    <SingPanelEditor idSelector={bean.IDSignAndApprovalPanel} onChange={(e) => { setBean({ ...bean, IDSignAndApprovalPanel: e }) }} />
                                </div>
                            }
                            <div className="col-md-6">
                                <BasicSwitch label="Requiere control de versiones" estado={bean.RequiredVersionControl} eventChange={(e) => { setBean({ ...bean, RequiredVersionControl: e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label>Años de Retención</label>
                                <input type="number" className="form-control" value={bean.RetentionYears} onChange={(e) => { setBean({ ...bean, RetentionYears: e.target.value ? Number(e.target.value) : null }) }} />
                            </div>
                            <div className="col-md-12">
                                <EditorDOCMimeTypes
                                    label="Formatos permitidos"
                                    value={bean.MimeTypes}
                                    multiple
                                    onChange={(mimeTypes) => {
                                        setBean({
                                            ...bean,
                                            MimeTypes: mimeTypes.join(',')
                                        });
                                    }
                                    }
                                />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>


                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar Directorio {bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Documentos tipo TRD">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}